import { useEffect } from 'react';
import Link from 'next/link';

import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Lib
import { REPORTS, REPORTS_ACCOUNTS } from '@/lib/routes/privateRoutes';

// Components
import Button from '@/components/base/Button';
import H2 from '@/components/base/Headings/H2';
// Layouts
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import HistoryReports from '@/components/pages/reports/components/HistoryReports';
import ReportSectionTitle from '@/components/pages/reports/components/ReportSectionTitle';
import ScheduledReports from '@/components/pages/reports/components/ScheduledReports';

const Content = () => {
    const { t: tReports } = useTranslation('reports');

    /**
     * Add it for the anchor #history-reports-table
     * It doesn't trigger natively, because the DOM is not render directly
     */
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) element.scrollIntoView();
        }
    }, []);

    return (
        <>
            <header
                className="z-10 flex flex-wrap items-center gap-4 pb-5 sm:justify-between md:items-center md:pb-10"
                aria-label="Progress">
                <H2>{tReports('general.title')}</H2>
                <Button icon="plus" as={Link} href={REPORTS_ACCOUNTS} className="w-full sm:w-auto">
                    <span>{tReports('general.new_report')}</span>
                </Button>
            </header>
            <div className="space-y-10">
                {/* Scheduled report section */}
                <div className="w-full">
                    <ReportSectionTitle
                        title={tReports('general.scheduled_title')}
                        tooltip={tReports('general.scheduled_tooltip')}
                        withBorder={false}
                    />
                    <ScheduledReports />
                </div>
                {/* History report section */}
                <div className="w-full" id="history-reports-table">
                    <ReportSectionTitle
                        title={tReports('general.history_title')}
                        tooltip={tReports('general.history_tooltip')}
                        withBorder={false}
                    />
                    <HistoryReports />
                </div>
            </div>
        </>
    );
};

const Reports = () => {
    return (
        <WrapperSwitchLayout>
            <Content />
        </WrapperSwitchLayout>
    );
};

export const getServerSideProps = TranslationService.getTranslationMessagesFromRoute(REPORTS);

export default Reports;
